{
  "version": 1,
  "initialCoins": 250,
  "rename": {
    "freeChanges": 3,
    "paidBaseCoins": 100,
    "curve": "triangular"
  },
  "progression": {
    "xpBase": 100,
    "xpPerLevel": 35,
    "levelUpCoinBonus": 25
  }
}
